<template>
  <div>
    <DepartmentLiquidation
      :title="'CHEQUE DAMAYAN SALES DRIVE'"
    />
  </div>
</template>
<script>
  import DepartmentLiquidation
    from '@/views/input_interface/monthly_liquidation/ChequeFundLiquidation'

  export default {
    components: {
      DepartmentLiquidation,
    },
  }
</script>
